import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IMessage } from "shared/types";
import { IStoreState } from "App/types";

export interface IMessageState {
  message: IMessage | null;
  buttons?: JSX.Element;
}

const initialState: IMessageState = { message: null };

const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessageModal: (_, { payload }: PayloadAction<IMessageState>) => {
      return payload;
    },
    clearMessageModal: () => {
      return initialState;
    },
  },
});

export const messageModalSelector = createSelector(
  (state: IStoreState) => state.message,
  message => message
);

export const { setMessageModal, clearMessageModal } = messageSlice.actions;
export const messageReducer = messageSlice.reducer;
